
import React from 'react';
import IRoute from './layout.state';

const HomePage = React.lazy(() => import('../pages/home/home.page'));
const ReturnTripPage = React.lazy(() => import('../pages/return-trip/return-trip.page'));
const AirportArrivalPage = React.lazy(() => import('../pages/airport-arrival/airport-arrival.page'));
const AirportDeparturePage = React.lazy(() => import('../pages/airport-departure/airport-departure.page'));
const SingleTripPage = React.lazy(() => import('../pages/single-trip/single-trip.page'));
const HourlyChartedPage = React.lazy(() => import('../pages/hourly-charted/hourly-charted.page'));
const TwoWayAirportPage = React.lazy(() => import('../pages/two-way-airport/two-way-airport.page'));
const UobSbf2026HomePage = React.lazy(() => import('../pages/uob-sbf-2026/uob-sbf-2026.home.page'));
const ResetPasswordPage = React.lazy(() => import('../pages/reset-password/reset-password.page'));
const VerifyEmailPage = React.lazy(() => import('../pages/verify-email/verify-email.page'));

const UserConfirmationPage = React.lazy(() => import('../pages/user-confirmation/user-confirmation.page'));
const UserConfirmationPaymentPage = React.lazy(() => import('../pages/user-confirmation/user-confirmation-payment.page'));
const UserConfirmationSuccessPage = React.lazy(() => import('../pages/user-confirmation/user-confirmation-success.page'));
const UserProfileSettingPage = React.lazy(() => import('../pages/user-profile-setting/user-profile-setting.page'));
const UserManageBookingPage = React.lazy(() => import('../pages/user-manage-booking/user-manage-booking.page'));
const UserBillingPage = React.lazy(() => import('../pages/user-billing/user-billing.page'));
const UserOutstandingPage = React.lazy(() => import('../pages/user-outstanding/user-outstanding.page'));
const UserDetailBookingPage = React.lazy(() => import('../pages/user-detail-booking/user-detail-booking.page'));

export const routes: IRoute[] = [
  { path: '/', component: HomePage },
  { path: '/uob-sbf-2026', component: UobSbf2026HomePage },
  { path: '/return-trip', component: ReturnTripPage },
  { path: '/airport-arrival', component: AirportArrivalPage },
  { path: '/airport-departure', component: AirportDeparturePage },
  { path: '/single-trip', component: SingleTripPage },
  { path: '/hourly-charted', component: HourlyChartedPage },
  { path: '/two-way-airport', component: TwoWayAirportPage },
  { path: '/reset-password', component: ResetPasswordPage },
  { path: '/verify-email', component: VerifyEmailPage },
];

export const privateRoutes: IRoute[] = [
  { path: '/user-confirmation', component: UserConfirmationPage },
  { path: '/user-confirmation-payment', component: UserConfirmationPaymentPage },
  { path: '/user-confirmation-success', component: UserConfirmationSuccessPage },
  { path: '/user-profile-setting', component: UserProfileSettingPage, showLogin: true },
  { path: '/user-manage-booking', component: UserManageBookingPage, showLogin: true },
  { path: '/user-billing', component: UserBillingPage, showLogin: true },
  { path: '/user-outstanding', component: UserOutstandingPage, showLogin: true },
  { path: '/user-detail-booking/:hash_id', component: UserDetailBookingPage, showLogin: true },
]

export default routes;
